export default __webpack_public_path__ + "static/media/messanger.30dbbcf6.png";